import { inject, Injectable, Injector } from '@angular/core';
import { ProjectService } from './project.service';
import { KitchenInspiration } from '../models/configurators-2d/tunnel/kitchen/kitchen-tunnel-dtos';
import { Vendor } from '../models/vendor';
import { logError } from './helpers/sentry.helper';
import { FrameFinish } from '../models/configurators-2d/applications/closet-doors-standard/frame-finish';
import { Range } from '../models/configurators-2d/applications/closet-doors-standard/range';

@Injectable({
  providedIn: 'root',
})
export class CurrentService {
  kitchen: KitchenInspiration;

  storage: {
    inspirationId: number;
    legsId: number;
    frontId: number;
    boxId: number;
    handlesId: number;
  };

  vendor: Vendor;

  HBMProject: any;

  closetDoors: {
    id: string;
    title: string;
    emplacement: any;
    hasDrawers: boolean;
    drawersLocation: number;
    doorHeight: any;
    doorWidth: any;
    hasPlinth: boolean;
    openingPercentage: any;
    doorNumber: any;
    doors: any[];
    frameFinish: FrameFinish | null;
    resume: any;
    selectedEmplacement: any;
    selectedDoorId: number;
    /** Index (1-based) de la section actuellement sélectionnée dans la preview (étape Finitions). */
    selectedSectionIndex: number | undefined;
    needBaseboardCompensator: boolean;
    baseboardCompensatorQty: number;
    range: Range | null;
  };

  private injector = inject(Injector);

  constructor() {
    this.reset();
  }

  public async loadHBMProject(HBMProjectId: string, isLegacy: boolean = false) {
    try {
      // Insertion du CurrentService en lazy loading à cause d'une référence cyclique entre CurrentService et CustomerService
      const projectService = this.injector.get(ProjectService);
      let project: any = await projectService.getDetails(HBMProjectId.toUpperCase());
      this.setHBMProject({
        id: project.projectID,
        uuid: project.projectUUID,
        name: project.projectName,
        description: project.description,
        locked: project.is_locked,
        isLegacy: isLegacy,
      });
    } catch (err) {
      logError(err);
    }
  }

  public setHBMProject(input: any) {
    this.HBMProject = input;
  }

  reset() {
    this.HBMProject = null;

    this.kitchen = {
      styleId: -1,
      modelId: -1,
      layoutRef: null,
      ovenConfigurationRef: null,
      fridgeConfigurationRef: null,
    };
    this.storage = {
      inspirationId: -1,
      legsId: -1,
      frontId: -1,
      boxId: -1,
      handlesId: -1,
    };

    this.closetDoors = {
      id: null,
      title: 'Titre du projet',
      emplacement: null,
      hasDrawers: null,
      drawersLocation: null,
      doorHeight: null,
      doorWidth: null,
      hasPlinth: null,
      openingPercentage: null,
      doorNumber: null,
      doors: [],
      frameFinish: null,
      resume: null,
      selectedEmplacement: null,
      selectedDoorId: 1,
      selectedSectionIndex: undefined,
      needBaseboardCompensator: false,
      baseboardCompensatorQty: 0,
      range: null,
    };
  }
}
